import Swal from "sweetalert2";
import toast from "react-hot-toast";

export const toastSuccessMessage = (message) => {
  toast.success(message);
};

export const toastErrorMessage = (message) => {
  toast.error(message);
};

export const notificationSuccessMessage = (message) => {
  Swal.fire({ html: message, confirmButtonText: "باشه", icon: "success" });
};

export const notificationErrorMessage = (message) => {
  Swal.fire({ html: message, confirmButtonText: "باشه", icon: "error" });
};

export const notificationInfoMessage = (message) => {
  Swal.fire({ html: message, confirmButtonText: "باشه", icon: "info" });
};

export const notificationWarningMessage = (message) => {
  Swal.fire({ html: message, confirmButtonText: "باشه", icon: "warning" });
};

export const toastWarningMessage = (message) => {
  toast(message, {
    icon: <i className="fas fa-exclamation-triangle text-warning" />,
  });
};

export const areYouSureMessage = (
  func,
  html = "آیا مطمئنید؟",
  confirmButtonText = "بله مطمئنم"
) => {
  Swal.fire({
    html,
    icon: "warning",
    confirmButtonText,
    showCancelButton: true,
    cancelButtonColor: "#d33",
    confirmButtonColor: "#3085d6",
    cancelButtonText: "خیر",
  }).then((result) => {
    if (result.value) func();
  });
};
